module.exports = __webpack_public_path__ + "static/media/july 2021.10b092a7.svg";